/// <amd-module name="Build/Admin/Pool/Types" />

export interface IPipelinesConsumptionData {
    name: string;
    consumptionTimeline: IConsumptionNode[];
}

export interface IConsumptionNode {
    date?: string;
    consumption: number;
}

export enum PoolDataStrings {
    QueuedJobs = "QueuedJobs",
    RunningJobs = "RunningJobs",
    Concurrency = "Concurrency"
}

export enum Visibility {
    Private = "Private",
    Public = "Public"
}
